import { COURSE_PLATFORMS_TEXT } from 'constants/common';

import { idxMap } from 'helpers/styleMapIdx';

export const getTrainingSubtitle = (platform: any) => {
  if (!platform) {
    return '';
  }

  return idxMap(COURSE_PLATFORMS_TEXT as Record<string, string>, platform);
};
